import { IkasBlog } from ".";
import { initIkasBlogCategory } from "./category/init";

export function initIkasBlog(blog: IkasBlog) {
  initIkasBlogCategory(blog.category);
  blog.image = blog.imageId ? { id: blog.imageId, isVideo: false } : undefined;
}
